import {
  AfterViewInit,
  ChangeDetectorRef,
  Directive,
  ElementRef,
  Input,
  OnInit,
  Optional,
  Renderer2
} from '@angular/core';
import {ControlContainer, FormGroup, FormGroupDirective} from '@angular/forms';
import {HttpClient} from '@angular/common/http';
import {NzModalRef} from 'ng-zorro-antd/modal';
import {GnJsonUtils, GnObjectUtils} from 'geminis-ng-core';

export function controlContainerFactory(): FormGroupDirective {
  const formGroupDirective = new FormGroupDirective([], []);
  formGroupDirective.form = new FormGroup({});
  return formGroupDirective;
}

@Directive({
  selector: '[gn-form]',
  providers: [
    {provide: ControlContainer, useFactory: controlContainerFactory}
  ]
})
export class GnFormDirective implements OnInit, AfterViewInit {

  private colsValue: number;
  private innerBindValue: any;
  private binded = false;

  formGroup: FormGroup;

  @Input() url: string;
  @Input() labelWidth = 6;
  @Input() controlWidth = 18;
  @Input() dataId: string;
  @Input() dataKey: string;
  @Input() dataIncludes: string[];
  @Input() autoLoadData = true;
  @Input() submitMethod: 'post' | 'put' = 'put';
  @Input() loadMethod: 'post' | 'put' | 'get' = 'post';
  @Input() format: 'json' | 'form' = 'json';
  @Input() submitOptions: any;
  @Input() loadOptions: any;
  @Input() defaultValue: any;

  @Input() set cols(value: number) {
    this.colsValue = value;
    if (!this.colsValue || this.colsValue < 1) {
      return;
    }
    this.renderer.setStyle(this.elementRef.nativeElement, 'display', 'grid');
    this.renderer.setStyle(this.elementRef.nativeElement, 'grid-template-columns', 'repeat(' + this.colsValue + ', 1fr)');
  }

  get cols(): number {
    return this.colsValue;
  }

  @Input() set bindValue(value: any) {
    this.binded = false;
    this.innerBindValue = value;
    this.formGroup.patchValue(value);
    this.binded = true;
  }

  constructor(private controlContainer: ControlContainer,
              private elementRef: ElementRef,
              private renderer: Renderer2,
              private http: HttpClient,
              private changeDetectorRef: ChangeDetectorRef,
              @Optional() modalRef: NzModalRef) {
    this.formGroup = controlContainer.control as FormGroup;
    this.formGroup.valueChanges.subscribe(newValue => {
      if (modalRef) {
        modalRef.updateConfig({nzOkDisabled: this.formGroup.invalid});
      }
      if (this.innerBindValue && this.binded) {
        Object.assign(this.innerBindValue, newValue);
      }
    });
  }

  setValue(value: any): void {
    this.defaultValue = value;
    this.formGroup.patchValue(value);
  }

  get submitValue(): any {
    let submitValue: any;

    if (this.defaultValue) {
      submitValue = Object.assign(GnObjectUtils.deepCopy(this.defaultValue), this.formGroup.value);
    } else {
      submitValue = this.formGroup.value;
    }

    if (this.format === 'form') {
      submitValue = GnJsonUtils.obj2FormData(submitValue);
    }

    return submitValue;
  }

  submit(): Promise<any> {
    if (!this.url) {
      return Promise.resolve(this.submitValue);
    } else {
      const options = Object.assign({body: this.submitValue}, this.submitOptions);
      return this.http.request(this.submitMethod, this.url, options).toPromise();
    }
  }

  loadData(): Promise<any> {
    if (!this.url || !this.dataId) {
      if (this.defaultValue) {
        this.formGroup.patchValue(this.defaultValue);
      }
      return Promise.resolve(null);
    }

    const queryParameter = {
      pageSize: 1,
      pageIndex: 0,
      includes: this.dataIncludes,
      filterGroup: {
        type: 'and',
        filters: [{field: this.dataKey, compareType: '=', value: this.dataId}]
      }
    };

    const options = Object.assign({body: queryParameter}, this.loadOptions);

    return this.http.request(this.loadMethod, this.url, options)
      .toPromise()
      .then((resp: any) => {
        if (resp.content.length === 0) {
          throw new Error(`未找到数据[${this.dataId}]`);
        }
        this.defaultValue = this.defaultValue || {};
        Object.assign(this.defaultValue, resp.content[0]);
        this.formGroup.patchValue(this.defaultValue);
        return this.defaultValue;
      });
  }

  ngOnInit(): void {
    if (this.autoLoadData) {
      this.loadData();
    }
  }

  ngAfterViewInit(): void {
    this.changeDetectorRef.detectChanges();
  }

}
